import { Stack, Textarea, TextInput, useForm } from "@dutyon/ui-kit";

interface TermsCategoryFormProps {
  formId: string;
  onSubmit: (values: { key: string; name: string; description: string }) => void;
}

export function TermsCategoryForm({ formId, onSubmit }: TermsCategoryFormProps) {
  const form = useForm({
    initialValues: {
      key: "",
      name: "",
      description: "",
    },
    validate: {
      key: (value) => {
        if (!value.trim()) return "구분 KEY를 입력해 주세요.";
        const keyRegex = /^[A-Z][A-Z0-9_]*$/;
        if (!keyRegex.test(value)) {
          return "영문 대문자, 숫자, 언더바(_)만 가능하며 숫자로 시작할 수 없습니다. (예: PRIVACY_POLICY)";
        }
        return null;
      },
      name: (value) => {
        if (!value.trim()) return "표시명을 입력해 주세요.";
        return null;
      },
    },
  });

  return (
    <form id={formId} onSubmit={form.onSubmit(onSubmit)} noValidate>
      <Stack gap="md">
        <TextInput
          label="구분 KEY"
          placeholder="예: PRIVACY_POLICY, THIRD_PARTY_SHARING"
          description="영문 대문자, 숫자, 언더바(_)만 사용 가능합니다."
          required
          {...form.getInputProps("key")}
        />
        <TextInput
          label="표시명 (Name)"
          placeholder="예: 개인정보 처리방침, 제3자 정보제공 동의"
          required
          {...form.getInputProps("name")}
        />
        <Textarea
          label="설명"
          placeholder="해당 약관 구분에 대한 간략한 용도를 적어주세요."
          minRows={3}
          {...form.getInputProps("description")}
        />
      </Stack>
    </form>
  );
}
